module.exports = __webpack_public_path__ + "img/1.ddd1ca9c.png";